import { useRef } from "react";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

/**
 * Magnetic interactive wrapper. Renders the chosen element type and applies
 * a mouse-follow translation + halo via direct DOM mutation.
 */
function applyMagnet(el, e, strength) {
  const rect = el.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;
  const cx = rect.width / 2;
  const cy = rect.height / 2;
  const dx = ((x - cx) / cx) * strength;
  const dy = ((y - cy) / cy) * strength;
  el.style.setProperty("--mx", `${x}px`);
  el.style.setProperty("--my", `${y}px`);
  el.style.transform = `translate(${dx}px, ${dy}px)`;
}

export default function MagneticButton({
  children,
  className,
  as = "button",
  strength = 18,
  ...props
}) {
  const ref = useRef(null);

  const onMove = (e) => {
    if (ref.current) applyMagnet(ref.current, e, strength);
  };
  const onLeave = () => {
    if (ref.current) ref.current.style.transform = "translate(0, 0)";
  };

  const baseClass = cn(
    "btn-magnetic relative inline-flex items-center justify-center gap-2 transition-transform duration-200 ease-out will-change-transform",
    className,
  );

  if (as === Link || as === "Link") {
    return (
      <Link
        ref={ref}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        className={baseClass}
        {...props}
      >
        {children}
      </Link>
    );
  }
  if (as === "a") {
    return (
      <a
        ref={ref}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        className={baseClass}
        {...props}
      >
        {children}
      </a>
    );
  }
  return (
    <button
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={baseClass}
      {...props}
    >
      {children}
    </button>
  );
}
